module.exports = __webpack_public_path__ + "static/img/revise.fd9eb916.png";